import { render, staticRenderFns } from "./BlacklistedResources.vue?vue&type=template&id=3d3a7532&"
import script from "./BlacklistedResources.js?vue&type=script&lang=js&"
export * from "./BlacklistedResources.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports